<template>
  <ExamReport
    @created="onReportCreated"
    @goRepeat="goRepeat"
    @goAnalysis="goAnalysis"
    reportType="package"
    isPackage
  >
    <template v-slot:bread="{ detail }">
      <div class="bread">
        <ExamIndexBread></ExamIndexBread>
        <span class="slash">/</span>
        <router-link :to="{ name: 'ExamPackage' }">套卷练习</router-link>
        <span class="slash">/</span>
        <router-link :to="{ name: 'ExamPackagePaper', query: { id: package_id } }">
          {{ package_name }}
        </router-link>
        <span class="slash">/</span>
        <span>{{ detail.title }}</span>
        <span class="slash">/</span>
        <span class="current">练习报告</span>
      </div>
    </template>
  </ExamReport>
</template>
<script>
import ExamReport from './components/ExamReport';
import ExamIndexBread from './components/ExamIndexBread.vue';

export default {
  name: 'ExamPackageReport',
  components: {
    ExamReport,
    ExamIndexBread,
  },
  data() {
    return {
      detail: {},
      package_id: this.$route.query.package_id,
      package_name: this.$route.query.package_name,
      paper_id: this.$route.query.paper_id,
    };
  },
  methods: {
    onReportCreated(detail) {
      this.detail = detail;
    },
    async goRepeat() {
      let data = await this.$http.post('/api/app/practice/report', {
        type: 5,
        report_id: this.$route.query.id,
      });
      if (data.length === 0) {
        this.$info('当前没有题目可以练习');
        return;
      }
      this.$router.push({
        name: 'ExamPackageDo',
        query: {
          id: data,
          package_id: this.package_id,
          package_name: this.package_name,
          paper_id: this.paper_id,
        },
      });
    },
    goAnalysis(type) {
      this.$router.push({
        name: 'ExamPackageAnalysis',
        query: {
          id: this.$route.query.id,
          type: type,
          package_id: this.package_id,
          package_name: this.package_name,
          paper_id: this.paper_id,
          paper_name: this.detail.title,
          is_can_do: this.$route.query.is_can_do,
        },
      });
    },
  },
};
</script>
